import '../../App.css';
import React, { useState, useEffect } from "react";
import useBackend, { SpinnerX } from '../../services/useBackend_v2';
import { Alert,Container, Button ,Form} from 'react-bootstrap';
import {Sida,Rubrik,ContentWrapper,Artickel} from "../ContentStyles";
import {Branding} from '../../services/misc';

export default function ChangePassword() { 
  const { loading, data, Refresh, resultVariant, resultVisible, resultText, Update } = useBackend('');

  async function handleSubmit(e) {
    e.preventDefault();
    const formData = new FormData(e.target),formDataObj = Object.fromEntries(formData.entries());
    await Update({ SystemID: "NS", FormData: formDataObj }, 'POST', 3000, '/backend/auth/password/change');
  }    
    
  return (
    <ContentWrapper>
      <Container>
      <Sida>
      <Artickel>
      <Rubrik>Ange nytt lösenord</Rubrik>
          <Form onSubmit={handleSubmit}>
                    <Form.Group className="mb-3">
                        <Form.Label className="FormHeaderText">Password</Form.Label>
                        <Form.Control type="password" name="password" />
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label className="FormHeaderText">Password</Form.Label>
                        <Form.Control type="password" name="password_validate" />
                    </Form.Group>                                        

                    <Form.Group className="mb-3"  hidden={!loading}>
                        <SpinnerX  />
                    </Form.Group>                                      
                        
                    <Form.Group className="mb-3"  hidden={!resultVisible}>
                        <Alert variant={resultVariant}  className="FormSpace">{resultText}</Alert> 
                    </Form.Group>        

                    <Form.Group className="mb-3">
                        <Button className="QmeButton" style={{backgroundColor:Branding().ButtonColor}} variant="primary" type="submit">Skicka</Button>
                    </Form.Group>  
          </Form>
        </Artickel>
      </Sida>
      </Container>
    </ContentWrapper>
  );
};